import {
  Circle,
  CircleCheck,
  CircleDashed,
  CircleX,
  LoaderCircle,
  TriangleAlert,
} from 'lucide-react';
import React from 'react';

import type { PreviewSaveStatus } from './setting-preview.types';

/** Maps a save status to its corresponding icon with appropriate color. */
export const SaveStatusIcon = ({ status }: { status: PreviewSaveStatus }): React.ReactElement => {
  switch (status) {
    case 'validation-warning':
      return (
        <TriangleAlert
          className="size-6 text-warning"
          aria-hidden="true"
          data-component="SaveStatusIcon"
        />
      );
    case 'pending':
      return (
        <div
          className="flex items-center justify-center rounded-full"
          data-component="SaveStatusIcon"
        >
          <LoaderCircle className="size-6 animate-spin text-muted-foreground" aria-label="Saving" />
        </div>
      );
    case 'failed':
      return (
        <CircleX
          className="size-6 text-ckds-text-fg-bad"
          aria-label={'Failed'}
          data-component="SaveStatusIcon"
        />
      );
    case 'cancelled':
      return (
        <CircleX
          className="size-6 text-ckds-text-fg-tier3"
          aria-label={'Cancelled'}
          data-component="SaveStatusIcon"
        />
      );
    case 'completed':
      return (
        <CircleCheck
          className="size-6 text-ckds-text-fg-good"
          aria-label="Completed"
          data-component="SaveStatusIcon"
        />
      );
    case 'queued':
      return (
        <CircleDashed
          className="size-6 text-muted-foreground"
          aria-label="Queued"
          data-component="SaveStatusIcon"
        />
      );
    default:
      return (
        <Circle
          className="size-6 bg-transparent stroke-input stroke-1"
          aria-hidden="true"
          data-component="SaveStatusIcon"
        />
      );
  }
};
